module.exports = __webpack_public_path__ + "static/media/preview_white.0fe46777.svg";